import React from 'react';

interface EmailColumnProps {
  email: string;
}

export default React.memo((props: EmailColumnProps) => {
  return <>{props.email || '-'}</>;
});
